
define('jst!peoplefinder/_contacts',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="contacts-tab">\n  <div class="search">\n    <span class="icon-16 icon-magnifier"></span>\n    <input type="text" placeholder="<%=translations.placeholder%>" />\n  </div>\n  <div class="all-contacts">\n    <input type="checkbox" id="select-all-checkbox" name="all-contacts-checkbox" />\n    <label for="all-contacts-checkbox"><%=t(\'All contacts #peoplefinder\')%></label>\n  </div>\n  <div class="contacts-container">\n\n  </div>\n</div>\n');
 });

